// src/app/shared/product-code-to-name.pipe.ts

import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'productCodeToName',
  standalone: false
})
export class ProductCodeToNamePipe implements PipeTransform {
  readonly productCodeMapping: { [key: string]: string } = {
    PDMS: 'PowerDMS',
    PLINE: 'PowerLINE',
    PFTO: 'PowerREADY',
    PTIME: 'PowerTIME',
    PACCR: 'PowerACCRED'
  };

  transform(value: string): string {
    return this.getProductNameByCode(value);
  }

  getProductNameByCode(code: string): string {
    return this.productCodeMapping[code] || code;
  }
}
